import React from "react";
import { Form as AntdForm } from "antd";
import { FormContext } from "./FormContext";

export const Form = React.forwardRef((props, ref) => {
  const { form: formProps, children } = props;
  const { form, ...formPropsCopy } = Object.assign({}, props);
  const [ldForm] = AntdForm.useForm();

  return (
    <FormContext.Provider value={formProps === undefined ? ldForm : formProps}>
      <AntdForm form={formProps === undefined ? ldForm : formProps} {...formPropsCopy}>
        {children}
      </AntdForm>
    </FormContext.Provider>
  );
});

Form.useForm = () => AntdForm.useForm();
